import { Country } from "../enum";


export function getCountryOptions(filter) {

    // @ts-ignore
    return Array.from(new Set([Country.NL, Country.BE, Country.DE, ...Object.keys(Country)]))
        .map(item => (
            {
                label: filter(item),
                value: item
            }
        ));
}